module.exports = __webpack_public_path__ + "static/img/banner_home03.520357c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_home03.jpg
// module id = n2H2
// module chunks = 15